import config from '@plone/volto/registry';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  heading: {
    id: 'Heading',
    defaultMessage: 'Heading',
  },
  headingLevel: {
    id: 'Heading level',
    defaultMessage: 'Heading level',
  },
  alignment: {
    id: 'Alignment',
    defaultMessage: 'Alignment',
  },
  showUnderline: {
    id: 'Show underline',
    defaultMessage: 'Show underline',
  },
});

export const headingSchema = (props) => {
  const show_alignment =
    config.blocks?.blocksConfig?.junts_heading?.show_alignment;
  const default_tag = config.blocks?.blocksConfig?.junts_heading?.default_tag;
  const allowed_headings =
    config.blocks?.blocksConfig?.junts_heading?.allowed_headings;
  const DEFAULT_HEADING_LEVELS = [
    ['h1', 'h1'],
    ['h2', 'h2'],
    ['h3', 'h3'],
    ['h4', 'h4'],
    ['h5', 'h5'],
    ['h6', 'h6'],
  ];

  const filterDefaultLevels = () => {
    if (allowed_headings) {
      return DEFAULT_HEADING_LEVELS.filter((item) =>
        allowed_headings.includes(item[0]),
      );
    } else {
      return DEFAULT_HEADING_LEVELS;
    }
  };

  return {
    title: props.intl.formatMessage(messages.heading),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [
          ...(allowed_headings.length > 1 ? ['tag'] : []),
          ...(show_alignment ? ['alignment'] : []),
          'showUnderline',
        ],
      },
    ],

    properties: {
      tag: {
        title: props.intl.formatMessage(messages.headingLevel),
        choices: filterDefaultLevels(),
        default: default_tag,
        noValueOption: false,
      },
      alignment: {
        title: props.intl.formatMessage(messages.alignment),
        choices: [
          ['left', 'left'],
          ['center', 'center'],
          ['right', 'right'],
        ],
        default: 'left',
      },
      showUnderline: {
        title: props.intl.formatMessage(messages.showUnderline),
        type: 'boolean',
        default: true,
      },
    },
    required: [],
  };
};
